import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

// api
import { getUserInfoFromMomthera, getUserProfileImageFromMomthera, putStaffProfileImgToMomthera } from "../../../services/apis/momthera/user";

// assets
import defaultProfile from '../../../assets/images/default_profile.jpeg';


function MomtheraMyPageMain() {
    const navigate = useNavigate();
    const profileImgRef = useRef(null);

    const [userInfo, setUserInfo] = useState({
        name: "",
        phone: "",
        institution: "",
        department: ""
    })
    const [profileImg, setProfileImg] = useState("");


    async function getUserInfoFromAPI() {
        try{
            const res = await getUserInfoFromMomthera();
            if(parseInt(res.status/200, 10)===1){
                const newUserInfo = {
                    name: res.data.name || "",
                    phone: res.data.phoneNumber ? `${res.data.phoneNumber.slice(0,3)}-${res.data.phoneNumber.slice(3,res.data.phoneNumber.length-4)}-${res.data.phoneNumber.slice(res.data.phoneNumber.length-4)}` : "",
                    institution: res.data.instName || "",
                    department: res.data.department || ""
                }

                setUserInfo(newUserInfo);
            }
        }catch(err){
            console.error(err);
        }        
    }

    async function getUserProfileImgFromAPI() {
        try{
            const res = await getUserProfileImageFromMomthera();
            if(parseInt(res.status/200, 10)===1){
                const imgURL = URL.createObjectURL(res.data);
                setProfileImg(imgURL || "")
            }else {
                throw new Error();
            }
        }catch(err){
            setProfileImg("");
        }
    }

    const handleClickUploadProfile = () => {
        profileImgRef.current.click();
    }

    const handleUploadProfileImg = async (e) => {
        if(e.target.files && e.target.files[0]){
            const uploadImg = e.target.files[0];
            const formData = new FormData();
            formData.append('imgfile', uploadImg);
            try {
                const res = await putStaffProfileImgToMomthera(formData);
                if(parseInt(res.status/200, 10)===1 && res.data.uploadStatus==="OK"){
                    getUserProfileImgFromAPI();
                }else{
                    throw new Error();                    
                }
            }catch(err){
                alert('이미지 업로드 실패');
            }
        }
    }

    useEffect(()=>{
        getUserInfoFromAPI();
        getUserProfileImgFromAPI();
    },[])

    return (
        <div className="dashboardContent dtx006">
			<div className="dashboardContent__title">
				<span className="dashboardContent__title__content">마이페이지</span>
			</div>
            <div className="mypage_main_wrapper dtx006">
                <div className="mypage_main_row_wrapper">
                    <div className="main_item_wrapper">
                    <div className="item_box momthera_profile" style={{alignItems: 'center'}}>
                        <div className="profile_image_wrapper">
                            <div className="profile_image_circle">
                                <img src={profileImg || defaultProfile} alt="user profile" />                              
                            </div>
                        </div>
                        <button
                            className="default_button"
                            onClick={handleClickUploadProfile}
                            style={{width: 'auto'}}
                        >
                            프로필 사진 변경
                        </button>
                        <input
                            ref={profileImgRef}
                            type="file"
                            accept=".png, .jpg, .jpeg"
                            style={{display: 'none'}}
                            onInput={handleUploadProfileImg}
                        />
                        <div className="name_wrapper">
                            <div className="name" style={{margin: 0}}>{userInfo.name}</div>
                        </div>
                    </div>
                    </div>
                    <div className="main_item_wrapper" style={{width: '35%'}}>
                        <div className="item_box">
                            <div className="item_title" style={{paddingLeft: '1rem'}}>개인 정보</div>
                            <div className="box_row">
                                <div className="momthera__mypage__item_label">
                                    아이디
                                </div>
                                <div className="item_label">
                                    {JSON.parse(localStorage.getItem('dtx006token')).email || ""}
                                </div>
                            </div>
                            <div className="box_row">
                                <div className="momthera__mypage__item_label">
                                    비밀번호
                                </div>
                                <div className="item_label">                                
                                    <button
                                        className="default_button"
                                        onClick={()=>navigate("/dtx006/mypage/modify-pw")}
                                        style={{width: 'auto'}}
                                    >
                                        비밀번호 변경
                                    </button>
                                </div>
                            </div>
                            <div className="box_row">
                                <div className="momthera__mypage__item_label">
                                    휴대폰번호
                                </div>
                                <div className="item_label momthera__mypage__item_label_row">
                                    {userInfo.phone}
                                    <button
                                        className="default_button"
                                        onClick={()=>navigate("/dtx006/mypage/modify-phone")}
                                        style={{width: 'auto'}}
                                    >
                                        휴대폰번호 변경
                                    </button>
                                    
                                </div>
                            </div>
                            <div className="button_wrapper_top">
                                <button
                                    className="default_button"
                                    onClick={()=>navigate("/dtx006/mypage/withdrawal/guide")}
                                >회원탈퇴</button>
                            </div>
                        </div>
                    </div>
                    <div className="main_item_wrapper">
                        <div className="item_box" style={{paddingTop: '2.5rem'}}>
                            <div className="item_title" style={{paddingLeft: '1rem'}}>기관 정보</div>
                            <div className="box_row">
                                <div className="momthera__mypage__item_label">
                                    기관명
                                </div>
                                <div className="item_label">
                                    {userInfo.institution}
                                </div>
                            </div>
                            <div className="box_row">
                                <div className="momthera__mypage__item_label">
                                    부서명
                                </div>
                                <div className="item_label">
                                    {userInfo.department}
                                </div>
                            </div>
                            <div className="button_wrapper_top">
                                <button
                                    className="default_button"
                                    onClick={()=>navigate("modify-institution")}
                                >수정하기</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MomtheraMyPageMain;